import React from "react";
import { CtaButton } from "../CtaButton";
import { AUTHOR_URL } from "../../data/offer";
export function Author() {
  return <section className="bg-white px-4 py-16 sm:py-20" data-id="element-66" data-mp="1ht3thgky4c62">
      <div className="mx-auto max-w-5xl" data-id="element-67" data-mp="1wgf3he1hbo42">
        <div className="grid items-start gap-8 md:grid-cols-[minmax(0,22rem)_1fr] md:gap-12" data-id="element-68" data-mp="1wi89qs86k6bj">
          <img src={AUTHOR_URL} alt="Dr. Elena Martins in a communication support classroom" className="aspect-[4/5] w-full rounded-3xl object-cover object-top md:aspect-[3/5]" data-id="element-69" data-mp="1rp6togw8m0qd" />
          <div data-id="element-70" data-mp="20kd1tmizcuw2">
            <p className="text-sm font-black uppercase tracking-wide text-brand" data-id="element-71" data-mp="2ffj88alzmvpx">Meet your educational author</p>
            <h2 className="mt-2 text-4xl font-black leading-tight text-navy" data-id="element-72" data-mp="2agpuqi6pb4pr">Dr. Elena Martins</h2>
            <p className="mt-1 text-lg font-extrabold text-ink/70" data-id="element-73" data-mp="l18hfwlu1rhi">AAC & Communication Support Educational Author</p>

            <div className="mt-6 space-y-4 text-lg font-semibold leading-relaxed text-ink/85" data-id="element-74" data-mp="g3713jfsk69q">
              <p className="text-2xl font-black text-navy" data-id="element-75" data-mp="3gf5ndz5v3war">Communication is deeply personal.</p>
              <p data-id="element-76" data-mp="3kfg52930ob5g">
                Every autistic child has their own strengths, interests, preferences, and ways of connecting with the
                world.
              </p>
              <p data-id="element-77" data-mp="3u5r9rxuiyode">
                That’s why I believe communication support resources should encourage individualized planning rather
                than assume that every child needs the same activities, goals, or communication system.
              </p>
              <p data-id="element-78" data-mp="7wzq3ahiegi8">
                The idea behind the Autism Communication Support Blueprint™ is simple: bring together foundational
                communication concepts, practical observation worksheets, visual planning resources, and
                collaboration tools in one organized educational collection.
              </p>
              <p data-id="element-79" data-mp="2dtvpu36uro6s">
                My goal is to help you spend less time searching through disconnected materials and more time
                thoughtfully organizing communication opportunities that respect each child’s individuality.
              </p>
              <p className="rounded-2xl bg-sun-soft p-5 font-bold text-navy" data-id="element-80" data-mp="3h3qazwn63rno">
                The materials are not intended to replace your expertise. They’re designed to support the
                thoughtful work you already do.
              </p>
            </div>
            <p className="mt-4 text-xs font-semibold text-ink/50" data-id="element-81" data-mp="8ugbtcgf0aw2">
              Dr. Elena Martins is a fictional author persona representing this educational resource collection. The
              name and professional presentation do not constitute verified clinical credentials.
            </p>
          </div>
        </div>

        <p className="mt-12 text-balance text-center text-2xl font-black uppercase leading-tight text-navy" data-id="element-82" data-mp="dmrf8pad6etd">
          Start organizing your communication support resources today.
        </p>
        <div className="mt-6" data-id="element-83" data-mp="mnfrbeg7653m">
          <CtaButton label="Yes! I want the complete Blueprint™" sub="Get All 6 Volumes + 5 Bonuses for $27" data-id="element-84" data-mp="mo7lcku5burs" />
        </div>
      </div>
    </section>;
}